import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const UserManagement = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
      }}
    >
      <Box height="100%">
        <Outlet />
      </Box>
    </Box>
  );
};

export default UserManagement;
